import { render, staticRenderFns } from "./examine2.vue?vue&type=template&id=9bd42724&scoped=true&"
import script from "./examine2.vue?vue&type=script&lang=js&"
export * from "./examine2.vue?vue&type=script&lang=js&"
import style0 from "./examine2.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./examine2.vue?vue&type=style&index=1&id=9bd42724&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd42724",
  null
  
)

export default component.exports